import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";

import { authenticateUser, signoutUser } from "../../actions/UserActions";

import Auth from "../../services/AuthCentral/AuthService";

import PasswordEye from "../Shared/OmniFormGroup/PasswordEye";
import Axios from "axios";
import defaultBg from "../../assets/backgrounds/bloom.jpg";
import defaultLogo from "../../assets/logos/Logo-Oasis.svg";
import signInWithGoogle from "../../assets/oauth/oAuth-Google.svg";
import signInWithMicrosoft from "../../assets/oauth/oAuth-MS.svg";
import Paths from "../../constants/Paths";
import ForgotPasswordLink from "./ForgotPasswordLink";

const host = window.location.hostname;
let abnSSO = "https://vm00000617.nl.eu.abnamro.com:9031";
const clientId = "AABPaperArchive";
if (host === "hub.omnidox5.com") {
  abnSSO = "https://security-ifs.connect.abnamro.com";
}
const redirectUri = `${window.location.origin}/login`;

class Login extends Component {
  state = {
    fieldValues: {
      email: "",
      password: "",
    },
    background: defaultBg,
    redirectPath:
      this.props.location.state &&
      this.props.location.state.from &&
      this.props.location.state.from.pathname &&
      this.props.location.state.from.pathname,
  };
  componentDidMount() {
    if (this.props.location.search) {
      const secretKey =
        "8h0ooKAA19pGN65sQU1MxHsBe7Y5oB8IpyDb5CPvlfprDCO5PXpebIDc5tnzmYEg";

      const code = this.props.location.search.replace("?code=", "");
      const body = `grant_type=authorization_code&client_id=${clientId}&client_secret=${secretKey}&code=${code}&redirect_uri=${redirectUri}`;
      const headers = {
        "Content-Type": "application/x-www-form-urlencoded",
      };
      console.log(this.props.location);
      console.log(body);
      console.log(headers);
      Axios.post(`/abnsso`, body, {
        headers,
      })
        .then((resp) => {
          const token = Auth.decodeToken(resp.data.id_token);
          this.props.authenticateUser(token.userid, "", true, 3 /*ABN_AMRO*/, {
            customerid: ["23839"],
            firstname: [token.given_name],
            lastname: [token.family_name],
            email: [token.email],
            requestactionsvalue: ["15"],
            employeegroupid: ["147"],
          });
        })
        .catch((err) => console.log(err));
    }
  }
  handleChange = (field, value) => {
    this.setState({
      fieldValues: {
        ...this.state.fieldValues,
        [field]: value,
      },
    });
  };

  clearState = () => {
    this.setState({ email: "", password: "" });
  };

  render() {
    const { User, _, authenticateUser, customSiteConfigurations } = this.props;
    const { fieldValues } = this.state;
    if (User && !User.isAuthenticated && User.redirectTo2FA) {
      return <Redirect to={User.userStatus === "1" ? "/" : "/TwoFAuth"} />;
    } else if (User && User.isAuthenticated) {
      return <Redirect to={User.userStatus === "1" ? "/" : "/ResetPassword"} />;
    } else
      return (
        <div className="login-screen">
          <div className="login-screen-form-wrapper">
            <div className="bridgeMessage">
              {_.BridgeMessage}<br/>
              <a href="https://oasisbridge.oasisgroup.com/">https://oasisbridge.oasisgroup.com</a>
            </div>
            <img src={defaultLogo} alt={_.Logo} className="login-screen-logo" />
            <form className="login-screen-form">
              {User && User.invalidLogin ? (
                <div className="alert omni-alert-danger">
                  <i className="icon-omni-warning-circle" />
                  {_.LoginErrorMessage}
                </div>
              ) : null}
              <div className="form-group">
                <label htmlFor="email" className="sr-only">
                  {_.EmailAddress}
                </label>
                <div className="input-group">
                  <div className="input-group-prepend">
                    <div className="input-group-text">
                      <i className="icon-omni-email" />
                    </div>
                  </div>
                  <input
                    type="email"
                    className="form-control"
                    id="email"
                    placeholder={_.EmailAddress}
                    value={fieldValues.email}
                    onChange={(e) => this.handleChange("email", e.target.value)}
                    required={true}
                    autoComplete="username"
                    title={_.LoginEmailAddressHint}
                  />
                </div>
              </div>
              <div className="form-group">
                <label htmlFor="password" className="sr-only">
                  {_.Password}
                </label>
                <div className="input-group">
                  <div className="input-group-prepend">
                    <div className="input-group-text">
                      <i className="icon-omni-lock" />
                    </div>
                  </div>
                  <PasswordEye
                    type="password"
                    className="form-control"
                    id="password"
                    placeholder={_.Password}
                    value={fieldValues.password}
                    onChange={(e) =>
                      this.handleChange("password", e.target.value)
                    }
                    required={true}
                    autoComplete="current-password"
                  />
                </div>
              </div>
              {customSiteConfigurations.ForgotPasswordAction
                ? customSiteConfigurations.ForgotPasswordAction({
                    _: _,
                  })
                : ForgotPasswordLink({
                    clearState: this.clearState,
                    ForgotPasswordLink: Paths.ForgotPassword,
                    _: _,
                  })}
              <button
                type="submit"
                className="btn btn-themed form-control"
                disabled={
                  fieldValues.email.trim().length < 4 ||
                  fieldValues.password.trim().length < 4
                }
                onClick={(e) => {
                  e.preventDefault();
                  authenticateUser(fieldValues.email, fieldValues.password);
                }}
              >
                {_.SignIn}
              </button>

              {/* <a href={ssoRedirectUrl}>Sign In With ABN AMRO Account</a> */}
            </form>
            {false ? (
              <>
                <p className="login-screen-or">{_.Or}</p>
                <div className="login-screen-oauth-login">
                  <button>
                    <img
                      src={signInWithGoogle}
                      alt={_.SignInWith + " Google"}
                    />
                  </button>
                  <button>
                    <img
                      src={signInWithMicrosoft}
                      alt={_.SignInWith + " Microsoft"}
                    />
                  </button>
                </div>
              </>
            ) : null}
            <p className="login-screen-footer-copyright">{_.FooterCopyright}</p>
          </div>
        </div>
      );
  }
}

const mapStateToProps = (state) => state;
const mapActionsToProps = {
  authenticateUser,
  signoutUser,
};
export default connect(mapStateToProps, mapActionsToProps)(Login);
